import { APP_BUILD_NUMBER } from '@/constants/appBuildNumber'

function getVersionNumber(): string {
  const fromEnv = (process.env.REACT_APP_VERSION || '').trim()
  if (fromEnv) return fromEnv
  return String(APP_BUILD_NUMBER)
}

/**
 * Nhãn version FE: số · môi trường · thời điểm build.
 * Ví dụ: `46 · dev · 26/03/2026 08:41` — để biết server đã build bản nào lúc nào.
 */
export function getAppVersionLabel(): string {
  const version = getVersionNumber()
  const env = (process.env.REACT_APP_ENV || 'local').trim() || 'local'
  const builtAt = (process.env.REACT_APP_BUILD_TIME || '').trim()
  if (builtAt) return `${version} · ${env} · ${builtAt}`
  return `${version} · ${env}`
}
